import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {SharedImports} from '@shared/shared-imports';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {take, takeUntil} from 'rxjs/operators';
import {MessageService} from 'primeng/api';
import {ContextService} from '@services/context.service';
import {OrganizationRegistrationModel} from '@app/models/organizations.model';
import {EmailVerificationModel, SelfRegistrationModel} from '@app/models/user-registration.model';
import {UserRegistrationService} from '@services/user-registration.service';
import {Subject} from 'rxjs';
import {ActivatedRoute} from '@angular/router';
import {TenantConfigService} from '@services/tenant-config.service';

@Component({
  selector: 'app-email-verification',
  templateUrl: './email-verification.component.html',
  styleUrls: ['./email-verification.component.scss'],
  imports: [
    SharedImports]
})

export class PublicEmailVerificationComponent implements OnInit, OnDestroy {
  mainForm: FormGroup;
  logo: string;
  isSaving: boolean = false;
  tenantName: string;
  organizationGuid: string;
  isLegacy: boolean = false;
  isProcessed: boolean = false;
  @Output() next = new EventEmitter<any>();
  @Output() updateData = new EventEmitter<any>();
  @Input() registrationProfile: SelfRegistrationModel;
  @Input() campaignId: number;
  @Input() organizationDetails: OrganizationRegistrationModel;

  private ngUnsubscribe = new Subject();

  constructor(private formBuilder: FormBuilder, public contextService: ContextService, private userRegistrationService: UserRegistrationService,
              private messageService: MessageService, private route: ActivatedRoute, private tenantConfigService: TenantConfigService) {
    this.mainForm = this.formBuilder.group({
      email: new FormControl(null, [Validators.required, Validators.email]),
    });
  }

  ngOnInit() {
    this.tenantConfigService.getTenantConfigBooleanAnonymous('SELFREGISTRATIONLEGACY', this.contextService.contextObject.tenantName).pipe(take(1))
      .subscribe({
        next: (res) => {
          this.isLegacy = res;
          if (this.isLegacy) {
            window.location.replace(`${window.location.origin}/public/user-registration`);
          }
        }
      });

    this.route.queryParams.subscribe({
      next: (params) => {
        // get the query parameters
        if (params && params.tenant) {
          this.tenantName = params.tenant;
        } else {
          this.tenantName = this.contextService.contextObject.tenantName;
        }
        this.organizationGuid = this.route.snapshot.paramMap.get('id');
        this.logo = this.contextService.contextObject.tenantLogo;
      }
    });


  }

  validateEmail() {
    const tempModelData: EmailVerificationModel = {
      TenantName: this.tenantName,
      EmailAddress: this.mainForm.get('email').value,
      OrganizationGuid: this.organizationGuid
    };
    this.isSaving = true;
    this.userRegistrationService.emailVerification(tempModelData)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (res) => {
          this.messageService.add({severity: 'success', summary: 'Success', detail: 'Your email verification has been sent.'});
          this.next.emit();
          this.isSaving = false;
          this.isProcessed = true;
        }, error: (e) => {
          console.log(e);
          if (e?.error?.Message) {
            this.messageService.add({severity: 'error', summary: 'Error', detail: e.error.Message.replace('UM: ', ''), life: 5000});
          } else {
            this.messageService.add({severity: 'error', summary: 'Error', detail: 'Our apologies... An error occurred. Please try again and let us know if it continues. Thank you!'});
          }
          this.isSaving = false;
        }
      });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next(true);
    this.ngUnsubscribe.complete();
  }
}
